import { render, staticRenderFns } from "./ListExample.vue?vue&type=template&id=39b6c2af&"
import script from "./ListExample.vue?vue&type=script&lang=js&"
export * from "./ListExample.vue?vue&type=script&lang=js&"
import style0 from "./ListExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/app/components/link/Link.vue').default,ListNewsItem: require('/app/components/list/ListNewsItem.vue').default})
